export default __webpack_public_path__ + "static/media/796.a1d3af0d.gif";